import React, { useEffect, useState } from 'react'
import { DeviceId, useDeviceChooserStore } from '~/service/DeviceChooser'
import { FormattedMessage } from '~/translations/utils'

const Settings: React.FC = ({}) => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>()
  const { input, output, setOutput, setInput } = useDeviceChooserStore()

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(devices => {
      setDevices(devices)
    })
  }, [])

  if (!devices) {
    return null
  }

  return (
    <div className="settings">
      <Select
        devices={devices}
        selected={input}
        type="audioinput"
        onChange={setInput}
      />

      {/* <MicVolume deviceId={input} /> */}

      <Select
        devices={devices}
        selected={output}
        type="audiooutput"
        onChange={setOutput}
      />
    </div>
  )
}

type SelectProps = {
  selected: DeviceId
  devices: MediaDeviceInfo[]
  type: MediaDeviceKind
  onChange: (id: string) => void
}

const Select: React.FC<SelectProps> = ({
  devices,
  selected,
  type,
  onChange,
}) => {
  return (
    <div className="field">
      <label className="label">
        {type == 'audioinput' ? (
          <FormattedMessage id="settings / audio / input" />
        ) : (
          <FormattedMessage id="settings / audio / output" />
        )}
      </label>
      <div className="control">
        <div className="select">
          <select
            onChange={e => onChange(e.target.value)}
            value={selected || ''}
          >
            {devices
              .filter(device => device.kind == type)
              .map((device, k) => (
                <option value={device.deviceId} key={k}>
                  {device.label}
                </option>
              ))}
          </select>
        </div>
      </div>
    </div>
  )
}

type MicVolumeProps = {
  deviceId: DeviceId
}

const MicVolume: React.FC<MicVolumeProps> = ({ deviceId }) => {
  useEffect(() => {
    // słuchaj

    // navigator.mediaDevices.getUserMedia({
    //   audio: {
    //     deviceId: deviceId,
    //   },
    // })

    return () => {
      // przestań
    }
  }, [deviceId])

  return <div>ww</div>
}

export default Settings
